/**
 * Controller: resourceAssignment
 */
angular.module('acme.common.controller.resourceAssignment', [
  'ui.grid',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.directive.cellInput',
  'acme.common.factory.notice'
])
.controller('ResourceAssignmentController', ['$scope', '$uibModal', 'ApiService', 'HelpersService', 'NoticeFactory', function($scope, $uibModal, ApiService, HelpersService, NoticeFactory) {

    $scope.gridLink = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ui-sref="application.resourcesInstances({ id: \'{{ row.entity.id }}\' })" role="link">{{row.getProperty(col.field)}}</a></div>';

    $scope.resourceAssignment = {

      resourceCategory: '',
      resourceCategoryName: '',

      isUpdated: true,

      resourcesSummaries: [],
      resourceTemplates: [],
      selectedAssignedResources: [],
      selectedUnassignedResources: [],
      editedAssignedResources: [],

      search: {},

      model: {},
      resourcesModel: {},
      assignedResourcesModel: {},
      unassignedResourcesModel: {},

      sortInfo: {
        columns: [],
        fields: [],
        directions: ['asc', 'desc']
      },
      multiSelectModal: {},

      selectedResourceTemplateId: '',

      defaultAssignmentColumns: [
        {
          field: 'name',
          displayName: 'Name',
          enableCellEdit: false
        },
        {
          field: 'description',
          displayName: 'Description',
          enableCellEdit: false
        }
      ],

      updateCache: [],
      assignmentFields: [],
      assignmentColumns: [{
        field: 'name',
        displayName: 'Name',
        enableCellEdit: false
      }],

      init: function() {
        $scope.$emit('Application::viewChange', { view: 'full' });

        $scope.$on('cellInputEdit', this.onCellInputEdit);
        $scope.$on('cellInputEditStart::modal', this.cellInputEditStartModal);

        $scope.$watch('resourceAssignment.sortInfo.columns', function() {
          console.log('ResourcesAssignController -> $watch -> resourceAssignment.sortInfo.columns', arguments);

        });
        $scope.$watch('resourceAssignment.sortInfo.fields', function() {
          console.log('ResourcesAssignController -> $watch -> resourceAssignment.sortInfo.fields', arguments);
        });

        $scope.$on('ngGridEventEndCellEdit', function () {
          console.log('ngGridEventEndCellEdit', arguments);
          if ($scope.resourceAssignment.updateCache.length > 0) {
            $scope.resourceAssignment.isUpdated = false;
            $scope.$apply();
          }
        });
        $scope.$on('ngGridEventStartCellEdit', function () {});
        $scope.$on( '$stateChangeSuccess', function(e, to, toParams, from, fromParams) {
          console.log('ResourceAssignmentController -> $stateChangeSuccess', to.name);
          if (to.name === 'application.resources.facilities.assign') {
            $scope.resourceAssignment.resourceCategory = 'Facility';
            $scope.resourceAssignment.resourceCategoryName = 'Facilities';
            $scope.resourceAssignment.defaultAssignmentColumns.push({
              field: 'capacity',
              displayName: 'Capacity',
              enableCellEdit: false
            });
          }else if (to.name === 'application.resources.staff.assign') {
            $scope.resourceAssignment.resourceCategory = 'Personnel';
            $scope.resourceAssignment.resourceCategoryName = 'Personnel';
          }else if (to.name === 'application.resources.equipment.assign') {
            $scope.resourceAssignment.resourceCategory = 'Equipment';
            $scope.resourceAssignment.resourceCategoryName = 'Equipment';
          }

          $scope.resourceAssignment.initResourceAssignments();

          $scope.$emit('Application::contentTitleChange', {
            title: $scope.resourceAssignment.resourceCategory + ' Assignment'
          });


        });

        $scope.$on('$destroy', this.onDestroy);
      },


      initResourceAssignments: function(id) {
        this.selectedResourceTemplateId = id || false;
        ApiService.resource.list(this.resourceCategory)
          .then(this.initResources)
          .then(this.initAssignedResources)
          .then(this.initTemplates)
          .then(this.initResource);
      },

      initResources: function(response) {
        $scope.resourceAssignment.resourcesSummaries = response.data.summaries;

        $scope.resourceAssignment.resourcesSummaries = $.each($scope.resourceAssignment.resourcesSummaries, function(index, value) {
          var selected;

          if (!$scope.resourceAssignment.selectedResourceTemplateId) {
            selected = (index === 0);
          }else{
            selected = ($scope.resourceAssignment.selectedResourceTemplateId === value.id);
          }

          if (selected) {
            value.selected = true;
            $scope.resourceAssignment.selectedResourceTemplateId = value.id;
          }else{
            value.selected = false;
          }
        });

        return ApiService.resource[$scope.resourceAssignment.resourceCategoryName.toLowerCase()].list();
      },

      initAssignedResources: function(response) {
        $scope.resourceAssignment.unassignedResourcesModel = response.data.payload;
        $scope.resourceAssignment.resourcesModel = response.data.payload;
        return ApiService.resource.instances.list($scope.resourceAssignment.selectedResourceTemplateId);
      },

      initTemplates: function(response) {
        $scope.resourceAssignment.model = response.data.payload;
        $scope.resourceAssignment.assignedResourcesModel = $scope.resourceAssignment.processResources(response.data.payload);
        $scope.resourceAssignment.updateUnassignedResources();
        return $scope.resourceAssignment.selectedResourceTemplateId;
      },

      initResource: function(id) {
        $scope.resourceAssignment.getResourceTemplate(id);
      },

      updateResourceAssignments: function() {
        ApiService.resource.instances.list($scope.resourceAssignment.selectedResourceTemplateId)
          .then(this.initTemplates)
          .then(this.initResource);
      },

      getResources: function () {
        ApiService.userProxy.list(HelpersService.getPaginator()).then(this.success.getResources, this.error.getResources);
      },

      getAssignedResources: function() {
        ApiService.resource.instances.list(this.selectedResourceTemplateId).then(this.success.getAssignedResources, this.error.getAssignedResources);
      },

      getUnassignedResources: function() {
        //ApiService.resource.list(this.selectedResourceTemplateId);
      },

      getResourceTemplates: function (filter) {
        this.summariesLoading = true;
        ApiService.resource.list(filter).then(this.success.getResourceTemplates, this.error.getResourceTemplates);
      },

      getResourceTemplate: function(id) {
        if (!this.resourcesSummaries[id]) {
          ApiService.resource.detail(id).then(this.success.getResourceTemplate, this.error.getResourceTemplate);
        }
      },

      getResourceSummaries: function() {
        return $scope.resourceAssignment.resourcesSummaries;
      },

      updateField: function(index, id) {

      },

      processResources: function(resources) {

        var i, ii,
          j, jj,
          rowUser = {},
          processed = [];

        for (i=0,ii=resources.length;i<ii;i++) {
          rowUser = {
            id: resources[i].id,
            ownerId: resources[i].ownerId,
            name: resources[i].name
          };

          if (resources[i].fields instanceof Array) {
            for (j=0,jj=resources[i].fields.length;j<jj;j++) {
              rowUser['id_' + resources[i].fields[j].fieldOrder] = HelpersService.getFieldValue(resources[i].fields[j]);
              console.log('ResourcesAssignController::processResources -> rowUser', rowUser['id_' + resources[i].fields[j].fieldOrder]);
            }
          }
          console.log('ResourcesAssignController::processResources -> rowUser', rowUser);

          processed.push(rowUser);
        }

        console.log('ResourcesAssignController::processResources', processed);
        return processed;
      },

      selectResource: function(resource) {
        this.updateResourceAssignments();//this.initResourceAssignments(resource.id);
      },

      updateAssignmentColumns: function(data) {

        var i, ii,
          j, jj,
          field,
          cellValue,
          fieldType,
          fieldValue,
          cellTemplate,
          editableCellTemplate;

        console.log('ResourcesAssignController::updateAssignmentColumns', data);

        this.assignmentColumns = [{
          field: 'name',
          displayName: 'Name',
          cellTemplate: $scope.gridLink,
          enableCellEdit: false
        }];

        console.log('ResourcesAssignController::updateAssignmentColumns -> this.defaultAssignmentColumns', this.defaultAssignmentColumns);
        console.log('ResourcesAssignController::updateAssignmentColumns -> this.assignmentColumns', this.assignmentColumns);


        if (data.fields instanceof Array && data.fields.length > 0) {
          // Clear out preserved data
          this.editedAssignedResources = [];

          for (j=0,jj=this.assignedResourcesModel.length;j<jj;j++) {
            this.editedAssignedResources.push({
              id: this.assignedResourcesModel[j].id,
              ownerId: this.assignedResourcesModel[j].ownerId,
              name: this.assignedResourcesModel[j].name
            });
            for (i=0,ii=data.fields.length;i<ii;i++) {
              fieldValue = HelpersService.getFieldValue(data.fields[i]);
              fieldType = HelpersService.getFieldType(data.fields[i]);
              //console.log('ResourcesAssignController::unique', 'id_' + data.fields[i].fieldOrder, this.assignedResourcesModel[j]);

              // Merge the template with the instance if it's an array value
              if (this.assignedResourcesModel[j].hasOwnProperty('id_' + data.fields[i].fieldOrder)) {
                //console.log('ResourcesAssignController::updateAssignmentColumns -> hasValue', j, 'id_' + data.fields[i].fieldOrder, this.editedAssignedResources[j]['id_' + data.fields[i].fieldOrder]);

                if (fieldType.type.indexOf('Array') > 0) {
                  console.log('ResourcesAssignController::unique');
                  this.editedAssignedResources[j]['id_' + data.fields[i].fieldOrder] = this.assignedResourcesModel[j]['id_' + data.fields[i].fieldOrder];
                  this.assignedResourcesModel[j]['id_' + data.fields[i].fieldOrder] = HelpersService.unique(fieldValue, this.assignedResourcesModel[j]['id_' + data.fields[i].fieldOrder]);
                }else if (!this.assignedResourcesModel[j]['id_' + data.fields[i].fieldOrder]) {
                  this.assignedResourcesModel[j]['id_' + data.fields[i].fieldOrder] = fieldValue;
                  this.editedAssignedResources[j]['id_' + data.fields[i].fieldOrder] = fieldValue;
                }else{
                  this.editedAssignedResources[j]['id_' + data.fields[i].fieldOrder] = this.assignedResourcesModel[j]['id_' + data.fields[i].fieldOrder];
                  console.log('ResourcesAssignController::updateAssignmentColumns -> hasValue', j, 'id_' + data.fields[i].fieldOrder, this.editedAssignedResources[j]['id_' + data.fields[i].fieldOrder]);
                }
              }

            }
          }

          console.log('ResourcesAssignController::unique', this.assignedResourcesModel);


          // Clear out assignment field columns
          this.assignmentFields = [];
          //this.sortInfo.fields = [];

          for (i=0,ii=data.fields.length;i<ii;i++) {
            cellValue = HelpersService.getFieldValue(data.fields[i]);
            field = HelpersService.low(HelpersService.getFieldType(data.fields[i]).type);
            console.log('ResourcesAssignController::updateAssignmentColumns', cellValue);

            cellTemplate = '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a>{{ COL_FIELD }}<span data-ng-if="!COL_FIELD">Select One</a></div>';

            if (cellValue instanceof Array) {
              editableCellTemplate = '<div>';
              if (data.fields[i].multiSelect) {
                editableCellTemplate += '<a data-cell-input="multiSelect" data-ng-model="modalWatcher">Select Values</a>';
              }else{
                editableCellTemplate += '<select data-cell-input data-ng-model="COL_FIELD" data-ng-options="field as field for field in resourceAssignment.assignedResourcesModel[ row.rowIndex ][\'id_'+data.fields[i].fieldOrder+'\']">';
                editableCellTemplate += '<option value="">Select One</option>';
                editableCellTemplate += '</select>';
              }
              editableCellTemplate += '</div>';
            }else{
              editableCellTemplate = '<div>';
              editableCellTemplate += '<input data-cell-input data-ng-model="COL_FIELD" />';
              editableCellTemplate += '</div>';
            }

            //this.sortInfo.fields.push('id_'+data.fields[i].fieldOrder);
            this.assignmentFields.push({
              field: 'id_'+data.fields[i].fieldOrder,
              displayName: data.fields[i].name,
              editableCellTemplate: editableCellTemplate,
              cellTemplate: cellTemplate
            });
          }

          this.assignmentColumns = this.assignmentColumns.concat(this.assignmentFields.slice(0));

        }

        this.resourceTemplates[data.id] = data;

      },

      updateUnassignedResources: function() {
        var i, ii,
          j, jj,
          unassigned,
          unassignedResources = [];

        for (i=0,ii=this.resourcesModel.length;i<ii;i++) {
          unassigned = true;
          for (j=0,jj=this.assignedResourcesModel.length;j<jj;j++) {
            if (this.resourcesModel[i].id === this.assignedResourcesModel[j].ownerId) {
              unassigned = false;
              console.log('ResourcesAssignController::updateUnassignedResources -> unassigned', this.resourcesModel[i].id, this.assignedResourcesModel[j].ownerId);
              break;
            }
          }

          if (unassigned) {
            unassignedResources.push(this.resourcesModel[i]);
          }

        }
        console.log('ResourcesAssignController::updateUnassignedResources', this.resourcesModel, unassignedResources);
        this.unassignedResourcesModel = unassignedResources;
      },

      assign: function() {

        var i, ii,
          data = {
            resourceTemplateId: this.selectedResourceTemplateId,
            entityIds: []
          };

        for (i=0,ii=this.selectedUnassignedResources.length;i<ii;i++) {
          data.entityIds.push(this.selectedUnassignedResources[i].id);
        }

        console.log('ResourcesAssignController::assign', data);
        ApiService.resource.instances.batchCreate(data).then(this.success.batchCreate, this.error.batchCreate);

      },

      unassign: function() {
        ApiService.resource.instances.remove(this.selectedAssignedResources).then(this.success.unassign, this.error.unassign);
      },

      update: function() {
        var i, ii;

        for (i=0,ii=this.updateCache.length;i<ii;i++) {
          ApiService.resource.instances.update(this.model[this.updateCache[i]]).then(this.success.update, this.error.update);
        }

      },

      success: {
        initResources: function(response) {
          $scope.resourceAssignment.getResources();
        },

        batchCreate: function(response) {
          console.log('ResourcesAssignController::success::batchCreate', response.payload);
          $scope.unassignedResourcesGridOptions.selectAll(false);
          $scope.resourceAssignment.initResourceAssignments($scope.resourceAssignment.selectedResourceTemplateId);
        },

        unassign: function(response) {

        },

        update: function(response) {
          $scope.resourceAssignment.updateCache = [];
          $scope.resourceAssignment.isUpdated = true;
        },

        getResources: function(response) {
          $scope.resourceAssignment.unassignedResourcesModel = response.data.payload;
          $scope.resourceAssignment.resourcesModel = response.data.payload;
        },

        getUnassignedResources: function(response) {
          $scope.resourceAssignment.unassignedResourcesModel = response.data.payload;
        },

        getAssignedResources: function(response) {
          console.log('ResourcesAssignController::getAssignedResources');
          $scope.resourceAssignment.assignedResourcesModel = $scope.resourceAssignment.processResources(response.data.payload);
          $scope.resourceAssignment.updateUnassignedResources();

        },

        getResourceTemplates: function(response, status, headers, config) {
          $scope.resourceAssignment.summariesLoading = false;
          $scope.resourceAssignment.resourcesSummaries = response.data.summaries;
          $scope.resourceAssignment.selectResource($scope.resourceAssignment.resourcesSummaries[0]);
        },

        getResourceTemplate: function(response) {
          $scope.resourceAssignment.updateAssignmentColumns(response.data.resourceType);
        }
      },

      error: {

        initResources: function(response) {},

        batchCreate: function(response) {

        },

        getResources: function(response) {

        },

        update: function(response) {

        },

        getUnassignedResources: function(response) {

        },

        getAssignedResources: function(response) {

        },

        getResourceTemplates: function(response, status, headers, config) {
          $scope.resourceAssignment.summariesLoading = false;
        },

        getResourceTemplate: function(response) {

        }
      },

      onDestroy: function() {
        $scope.$emit('Application::viewChange', { view: 'sidebar' });
      },

      cellInputEditStartModal: function(e, data) {
        console.log('ResourcesAssignController::cellInputEditStartModal', data);
        var self = $scope.resourceAssignment;

        self.multiSelectModal = $uibModal.open({
          templateUrl: 'common/includes/multiSelectModal.tpl.html',
          controller: ['$scope', '$uibModalInstance', 'ValidateService', 'NoticeFactory', function($scope, $uibModalInstance, ValidateService, NoticeFactory) {

            var i, ii,
              selected = false;

            // Populate possible values to the model for use in modal
            $scope.model = [];

            $scope.errors = [];

            $scope.fieldName = data.column.displayName;

            // Assign field values need selected in modal

            for (i=0,ii=self.assignedResourcesModel[data.rowIndex][data.column.field].length;i<ii;i++) {
              if (self.editedAssignedResources[data.rowIndex][data.column.field]) {
                // See if field value is selected
                if (self.editedAssignedResources[data.rowIndex][data.column.field] instanceof Array) {
                  selected = (self.editedAssignedResources[data.rowIndex][data.column.field].indexOf(self.assignedResourcesModel[data.rowIndex][data.column.field][i]) !== -1);
                }
              }
              console.log('ResourcesAssignController::cellInputEditStartModal -> selected', self.assignedResourcesModel[data.rowIndex][data.column.field][i], selected);
              $scope.model.push({
                name: self.assignedResourcesModel[data.rowIndex][data.column.field][i],
                selected: selected
              });
            }

            $scope.hasErrors = function() {
              return ($scope.errors.length > 0);
            };

            $scope.done = function () {
              $uibModalInstance.close($scope.model);
            };

            $scope.cancel = function () {
              $uibModalInstance.dismiss('cancel');
            };

            $scope.success = function(response) {
              $uibModalInstance.close(response);
            };

          }]
        });

        // Invoked when modal completes with close(params)
        self.multiSelectModal.result.then(function (values) {

          var i, ii,
            fieldValues = [];

          for (i=0,ii=values.length;i<ii;i++) {
            if (values[i].selected) {
              fieldValues.push(values[i].name);
            }
          }

          self.editedAssignedResources[data.rowIndex][data.column.field] = fieldValues;
          $scope.$broadcast('cellInputEdit', {
            rowIndex: data.rowIndex
          });

          console.log('ResourcesAssignController::cellInputEditStartModal::multiSelectModal::success', data.column.field, fieldValues, self.editedAssignedResources);
        }, function () {
          // Do nothing
        });
      },

      onCellInputEdit: function(e, data) {
        var i, ii,
          self = $scope.resourceAssignment;

        console.log('ResourcesAssignController::onCellInputEdit -> data', data);

        for (i=0,ii=self.model[data.rowIndex].fields.length;i<ii;i++) {
          // Reassign single value to field type value
          var fieldTypes = HelpersService.getFieldType(self.model[data.rowIndex].fields[i]),
            fieldKey = fieldTypes.simpleType + 'Value',
            fieldType = fieldTypes.simpleType + 'Type',
            altFieldKey = fieldTypes.simpleType + 'ArrayValue';

          if (self.model[data.rowIndex].fields[i].multiSelect) {
            // multiSelect fields are arrays so update the type
            fieldType = fieldTypes.simpleType + 'ArrayType';
            fieldKey = fieldTypes.simpleType + 'ArrayValue';
            altFieldKey = fieldTypes.simpleType + 'Value';
          }

          self.model[data.rowIndex].fields[i].type = HelpersService.cap(fieldType);
          self.model[data.rowIndex].fields[i][fieldKey] = self.editedAssignedResources[data.rowIndex]['id_'+self.model[data.rowIndex].fields[i].fieldOrder];
          self.model[data.rowIndex].fields[i][altFieldKey] = null;
        }

        if (self.updateCache.indexOf(data.rowIndex) === -1) {
          self.updateCache.push(data.rowIndex);
        }

        console.log('ResourcesAssignController::onCellInputEdit -> model', self.model);
      }

    };

    $scope.assignedResourcesGridOptions = {
      enableCellEdit: true,
      enableCellEditOnFocus: true,
      enableRowSelection: true,
      multiselect: true,
      paginate: false
      //selectWithCheckboxOnly: true,
      //showSelectionCheckbox: true
    };

    $scope.unassignedResourcesGridOptions = {
      paginate: false,
      enableRowSelection: true,
      multiselect: true
      //selectWithCheckboxOnly: false,
      //showSelectionCheckbox: true
    };

    $scope.resourceAssignment.init();
    

}]);